module.exports = __webpack_public_path__ + "static/img/tm.8e43ad9e.svg";